<template>
  <b-tab
    :title-link-class="tabClass"
  >
    <template #title>
      <strong class="fs-16">Admin</strong>
    </template>
    <b-row>
      <b-col cols="2">
        <h5>¿Qué acción desea ejecutar?</h5>
        <p class="text-muted" style="position: absolute; bottom: 0; right: 40px">
          Módulo admin: {{ currentUser | concatName2 }}
        </p>
      </b-col>
      <b-col>
        <table class="table table-borderless fs-18 table-sm mt-4">
          <tr>
            <td>Marcar como pendiente:</td>
            <td>
              <Button
                id="set-pending-btn"
                size="md"
                variant="blue"
                style="width: 100px;"
                :disabled="transaction.status != 'rechazada' || processing"
                @click="$emit('update-status', 'pendiente')"
              >
                <span>Cambiar</span>
              </Button>
            </td>
          </tr>
          <tr>
            <td style="width: 220px;">Reenviar dispatch:</td>
            <td>
              <Button
                id="resend-dispatch-btn"
                size="md"
                variant="yellow"
                style="width: 100px;"
                :disabled="(transaction.status != 'en_proceso' && transaction.status != 'pendiente') || !transaction.dispatch_id || sendingDispatch"
                @click="retryDispatch(transaction.dispatch_id)"
              >
                <span v-if="!sendingDispatch">Reenviar</span>
                <span v-else class="pl-1">
                  <b-spinner small type="grow"></b-spinner>
                  <span class="pl-1">Enviando</span>
                </span>
              </Button>
            </td>
          </tr>
          <tr>
            <td>Rechazar:</td>
            <td>
              <Button
                id="reject-btn"
                size="md"
                style="width: 100px;"
                :disabled="transaction.status != 'pendiente' && transaction.status != 'en_proceso'"
                @click="$emit('update-status', 'rechazada')"
              >
                Rechazar
              </Button>
            </td>
          </tr>
          <tr>
            <td>Eliminar:</td>
            <td>
              <Button
                id="delete-btn"
                size="md"
                variant="red"
                style="width: 100px;"
                :disabled="transaction.status == 'aprobada'"
                @click="inactivateTransaction"
              >
                Eliminar
              </Button>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import Button from '../../shared/Button.vue'

export default {
  name: 'AdminSection',
  components: { Button },
  props: {
    tabClass: {
      type: Array,
      required: true
    },
    transaction: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      processing: false,
      sendingDispatch: false
    }
  },
  computed: {
    currentUser () { return this.$store.state.currentUser },
    // canReject () {
    //   if (!this.transaction.id) return false

    //   return this.transaction.status == 'pendiente' || this.transaction.status == 'en_proceso'
    // }
  },
  methods: {
    // NEXT!
    // updateStatus () {

    // },
    retryDispatch (dispatch_id) {
      if (this.sendingDispatch || !dispatch_id) { return }
      if (window.confirm(`¿Desea reenviar el dispatch de device magic al usuario?`)) {
        this.sendingDispatch = true
        this.$http.patch(`/api/production/card_transactions/${this.transaction.id}/retry_dispatch`)
          .then((res) => {
            // console.log(res.data)
            this.$emit('display-alert', {
              message: 'Dispatch enviado correctamente',
              variant: 'success'
            })
          })
          .catch(e => {
            console.log(e)
            this.$emit('display-alert', {
              message: 'Error al reenviar dispatch, intente nuevamente',
              variant: 'danger'
            })
          })
          .finally( ()=> {
            setTimeout(() => {
              this.sendingDispatch = false
            }, 2000);
          })
      }
    },
    inactivateTransaction () {
      if (this.processing) { return }
      if (window.confirm(`¿Está seguro que desea eliminar la transacción?`)) {
        this.processing = true
        let data = {
          card_transaction : {
            status:  'inactiva',
            rejection_notes: `Transacción eliminada desde el módulo admin por el usuario ${this.currentUser.id} : ${this.currentUser.first_name} ${this.currentUser.last_name} ${this.currentUser.last_name2}`
          }
        }
        this.$http.patch(`/api/production/card_transactions/${this.transaction.id}/update_status`, data)
          .then(response => {
            // console.log('response', response.data);
            this.$emit('inactivate-transaction', this.transaction.id)
          })
          .catch(error => {
            console.log(error)
            this.$emit('display-alert', {
              message: 'Error al eliminar, intente nuevamente',
              variant: 'danger'
            })
          })
          .finally(() => this.processing = false )
      }
    }
  }
}
</script>
